import { FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function promoCodeValidator(): ValidatorFn {
  return (control: FormControl): ValidationErrors | null => {
    // Must be contain min 1 letter and/or number, max 12 characters
    const promoCodeRegex = /^[a-zA-Z\d]{1,12}$/;
    const promoCode: string = control.value;

    if (promoCode?.length > 1 && promoCode?.length < 13) {
      return promoCodeRegex.test(promoCode) ? null : { invalidPromocode: true };
    }
  };
}
